const isMissingMetric = (value) => value === null || value === undefined || value === "" || Number.isNaN(Number(value));

const metricText = (value, suffix = "") => {
  if (isMissingMetric(value)) return "확인불가";
  return `${value}${suffix}`;
};

const statusClass = (value) => {
  if (isMissingMetric(value)) return "warn";
  const number = Number(value);
  if (number >= 85) return "danger";
  if (number >= 70) return "warn";
  return "ok";
};

const healthLabel = (value) => {
  if (isMissingMetric(value)) return "확인불가";
  const number = Number(value);
  if (number >= 85) return "위험";
  if (number >= 70) return "주의";
  return "정상";
};

const normalizeStatus = (status) => String(status || "").toLowerCase();

function DashboardCards({ overview, users, isSuperAdmin, agentTasks, agentStatus }) {
  const waitingStatuses = new Set(["approval_required", "waiting_approval", "pending_approval", "pending"]);
  const succeededStatuses = new Set(["succeeded", "completed", "complete", "done", "success"]);
  const failedStatuses = new Set(["failed", "blocked", "error", "cancelled", "canceled", "rejected"]);

  const agentWaitingCount = agentTasks.filter((task) => waitingStatuses.has(normalizeStatus(task.status))).length;
  const agentSucceededCount = agentTasks.filter((task) => succeededStatuses.has(normalizeStatus(task.status))).length;
  const agentFailedCount = agentTasks.filter((task) => failedStatuses.has(normalizeStatus(task.status))).length;
  const server = overview?.server || {};
  const memoryText = `${metricText(server.memory_percent, "%")} / ${metricText(server.disk_percent, "%")}`;
  const serverTitle = server.ok === false && server.errors?.length ? server.errors.join("\n") : undefined;

  return (
    <>
      <div className="dashboard-grid">
        <div className="dashboard-card">
          <span>전체 회원</span>
          <strong>{overview?.users?.total ?? users.length}</strong>
        </div>
        <div className="dashboard-card warn">
          <span>승인 대기</span>
          <strong>{overview?.users?.pending ?? users.filter((user) => !user.is_approved).length}</strong>
        </div>
        <div className="dashboard-card">
          <span>최근 24시간 접속자</span>
          <strong>{overview?.activity?.active_users_24h ?? 0}</strong>
        </div>
        <div className="dashboard-card">
          <span>{isSuperAdmin ? "관리 회사" : "관리 범위"}</span>
          <strong>{isSuperAdmin ? (overview?.users?.companies ?? 0) : "소속 회사"}</strong>
        </div>
      </div>

      <div className="dashboard-grid system">
        <div className="dashboard-card">
          <span>대화방</span>
          <strong>{overview?.activity?.sessions ?? 0}</strong>
        </div>
        <div className="dashboard-card">
          <span>메시지</span>
          <strong>{overview?.activity?.messages ?? 0}</strong>
        </div>
        <div className={`dashboard-card ${statusClass(server.cpu_load_percent)}`} title={serverTitle}>
          <span>서버 부하</span>
          <strong>{metricText(server.cpu_load_percent, "%")}</strong>
        </div>
        <div className={`dashboard-card ${statusClass(server.memory_percent)}`} title={serverTitle}>
          <span>메모리 / 디스크</span>
          <strong>{memoryText}</strong>
        </div>
      </div>

      <div className="dashboard-grid system">
        <div className="dashboard-card">
          <span>지식베이스</span>
          <strong>{overview?.activity?.knowledge_items ?? 0}</strong>
        </div>
        <div className={`dashboard-card ${statusClass(server.disk_percent)}`} title={server.disk_path || serverTitle}>
          <span>디스크 상태</span>
          <strong>{healthLabel(server.disk_percent)}</strong>
        </div>
        <div className={`dashboard-card ${statusClass(server.memory_percent)}`} title={serverTitle}>
          <span>메모리 상태</span>
          <strong>{healthLabel(server.memory_percent)}</strong>
        </div>
        <div className="dashboard-card" title={serverTitle}>
          <span>평균 부하</span>
          <strong>{metricText(server.load_average)}</strong>
        </div>
      </div>

      <div className="dashboard-grid system">
        <div className={`dashboard-card ${agentStatus === "success" ? "ok" : "danger"}`}>
          <span>Agent 상태</span>
          <strong>{agentStatus === "success" ? "연결" : "확인 필요"}</strong>
        </div>
        <div className="dashboard-card warn">
          <span>Agent 승인 요청</span>
          <strong>{agentWaitingCount}</strong>
        </div>
        <div className="dashboard-card ok">
          <span>Agent 완료</span>
          <strong>{agentSucceededCount}</strong>
        </div>
        <div className="dashboard-card danger">
          <span>Agent 실패/차단</span>
          <strong>{agentFailedCount}</strong>
        </div>
      </div>
    </>
  );
}

export default DashboardCards;
